import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MatStepper } from '@angular/material/stepper';
import { SignoPadronesService } from 'src/app/services/entidades/signo-padrones.service';
import { CatalogoService } from 'src/app/services/shared/catalogo.service';
import { SignoLocalidadService } from 'src/app/services/entidades/signo-localidades.service';
import { SignoGerenciasService } from 'src/app/components/entidades/gerencias/gerencias-service/gerencias.service';
import { GuiMsjService } from 'src/app/services/shared/gui-msj.service';
import { EntidadesKeys } from 'src/app/enum/entidades-keys.enum';
import { SignoCentroMedicoService } from 'src/app/services/entidades/signo-centros-medicos.service';
import { SignoPlanService } from 'src/app/services/entidades/signo-planes.service';
import { MatDialog } from '@angular/material/dialog';
import { PadronImportHelpDialogComponent } from './padron-import-help-dialog/padron-import-help-dialog.component';
import { PadronFarmaciasService } from 'src/app/services/entidades/padron-farmacias.service';
import Swal from 'sweetalert2';
import { ProvinciaService } from '@services/provincias/provincias.service';
import { Provincia } from '@interfaces/interface-bakend/provincias/provincias.interface';

@Component({
  selector: 'app-padron-import-wizard',
  templateUrl: './padron-import-wizard.component.html',
  styleUrls: ['./padron-import-wizard.component.scss']
})
export class PadronImportWizardComponent implements OnInit {

  @ViewChild('stepper') stepper: MatStepper;

  // Step 1
  step1Form: FormGroup;
  selectedFile: File | null = null;
  gerenciadoras: any[] = [];
  localidades: any[] = [];
  zonas: any[] = [];
  provincias: Provincia[] = [];
  isProcessingPdf = false;
  
  // Step 1 selected references (for fallbacks)
  resLocalidad: any = null;
  resZona: any = null;
  resGerenciadora: any = null;

  // Filtro de localidades
  localidadesFiltradas: any[] = [];
  filtroLocalidad = '';

  // Step 2
  unmatchedSpecialties: any[] = [];
  catalogoEspecialidades: any[] = [];
  rubros: any[] = [];
  specialtyParentId = '';
  allSpecialtiesResolved = false;

  // Step 3
  isGeolocating = false;
  unmatchedAddresses: any[] = [];
  geoInitialCount = 0;
  geoCurrentCount = 0;
  geoProgress = 0;
  private geoInterval: any;
  private isGeoCancelled = false;
  
  planes: any[] = [];
  isMigratingData = false;
  migrationFinished = false;
  // Step 4: Automación de Zonas
  localidadZonaMap: { [key: string]: string } = {};
  createdPharmaciesSummary: any[] = [];
  pharmacyMigrationFailures: any[] = [];
  failedLocalitiesSummary: string[] = [];
  
  // Control de unificación manual
  showUnifyButton = false;
  hasUnified = false;
  lastGerenciadoraId = '';

  // Multi-tipo
  tipoImportacion: 'PADRON_MDP' | 'FARMACIAS' | null = null;
  pharmacyForm: FormGroup;
  isProcessingPharmacy = false;
  isDeletingPharmacies = false;
  enableDeletePharmacies = false;
  pharmacyFile: File | null = null;
  pharmacyImportResult: any = null;
  pharmacyDuplicates: any[] = [];
  
  // Localidades Faltantes (Farmacias)
  missingLocalities: { localidad: string, provincia: string, codigoPostal: string, farmaciaDemo: string }[] = [];
  isCheckingLocalities = false;
  allLocalitiesResolved = false;

  // Seguimiento de creaciones para el reporte final
  createdProvincesSummary: string[] = [];
  createdLocalitiesSummary: string[] = [];

  // Provincias Faltantes (Farmacias)
  missingProvinces: string[] = [];
  isCheckingProvinces = false;
  allProvincesResolved = false;

  constructor(
    private fb: FormBuilder,
    private padronesService: SignoPadronesService,
    private catalogoService: CatalogoService,
    private localidadService: SignoLocalidadService,
    private gerenciasService: SignoGerenciasService,
    private guiMsjService: GuiMsjService,
    private signoCentroMedicoService: SignoCentroMedicoService,
    private signoPlanService: SignoPlanService,
    private padronFarmaciasService: PadronFarmaciasService,
    private provinciaService: ProvinciaService,
    private dialog: MatDialog,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    console.log('hola');
    this.initForm();
    this.loadCatalogos();
  }

  initForm(): void {
    this.step1Form = this.fb.group({
      signoLocalidadId: ['', Validators.required],
      signoGerenciadoraId: ['', Validators.required],
      signoZonaId: ['', Validators.required],
      codigoArea: [''],
      planesIds: [[], Validators.required]
    });

    this.pharmacyForm = this.fb.group({
      especialidadId: ['', Validators.required],
      rubroId: ['', Validators.required],
      gerenciadoraId: ['', Validators.required],
      planesIds: [[], Validators.required]
    });
  }

  async loadCatalogos() {
    try {
      this.gerenciadoras = await this.gerenciasService.getGerencias();
      this.zonas = await this.catalogoService.findDescendantsByKey(EntidadesKeys.ZONAS);
      this.catalogoEspecialidades = await this.catalogoService.findDescendantsByKey(EntidadesKeys.ESPECIALIDADES);
      this.rubros = await this.catalogoService.findDescendantsByKey(EntidadesKeys.RUBROS);
      
      const parentSpec = await this.catalogoService.getFindByKey(EntidadesKeys.ESPECIALIDADES);
      this.specialtyParentId = parentSpec?._id || '';
      
      this.planes = await this.signoPlanService.getPlanes();

      // Cargar todas las localidades de una vez
      this.localidades = await this.localidadService.getLocalidades();
      this.localidadesFiltradas = this.localidades;

      // Cargar provincias
      this.provincias = await this.provinciaService.findAll();

      // Pre-selección de "FARMACIA"
      this.preselectPharmacyDefaults();

    } catch (error) {
      console.error('Error al cargar datos primarios:', error);
    }
  }

  preselectPharmacyDefaults() {
    if (this.pharmacyForm && this.rubros.length > 0) {
      const farmaciaRubro = this.rubros.find(r => r.concepto.toUpperCase().includes('FARMACIA'));
      const farmaciaEspec = this.catalogoEspecialidades.find(e => e.concepto.toUpperCase().includes('FARMACIA'));
      
      if (farmaciaRubro) this.pharmacyForm.patchValue({ rubroId: farmaciaRubro._id });
      if (farmaciaEspec) this.pharmacyForm.patchValue({ especialidadId: farmaciaEspec._id });
    }
  }

  openHelpDialog(): void {
    this.dialog.open(PadronImportHelpDialogComponent, {
      width: '600px',
      autoFocus: false,
      panelClass: 'custom-dialog-container'
    });
  }

  filtrarLocalidades() {
    if (!this.filtroLocalidad) {
      this.localidadesFiltradas = this.localidades;
      return;
    }
    const filterValue = this.filtroLocalidad.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    this.localidadesFiltradas = this.localidades.filter(loc => 
      loc.nombre.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").includes(filterValue)
    );
  }

  onLocalidadSearch(event: any) {
    this.filtroLocalidad = event.target.value;
    this.filtrarLocalidades();
  }

  onFileSelected(event: any) {
    const file = event.target.files[0];
    if (file && file.type === 'application/pdf') {
      this.selectedFile = file;
    } else {
      Swal.fire('Error', 'Debe seleccionar un archivo PDF', 'error');
      this.selectedFile = null;
      event.target.value = null;
    }
  }

  onPharmacyFileSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.pharmacyFile = file;
    }
  }

  setTipoImportacion(tipo: 'PADRON_MDP' | 'FARMACIAS') {
    this.tipoImportacion = tipo;
    this.resetWizard();
    this.cdr.detectChanges(); // Asegurar que los pasos se registren en el stepper
    this.stepper.next();
  }

  resetWizard() {
    // Reset MDP
    this.step1Form.reset();
    this.selectedFile = null;
    this.unmatchedSpecialties = [];
    this.unmatchedAddresses = [];
    this.showUnifyButton = false;
    this.hasUnified = false;
    
    // Reset Pharmacy
    this.pharmacyForm.reset();
    this.pharmacyFile = null;
    this.pharmacyImportResult = null;
    this.missingLocalities = [];
    this.allLocalitiesResolved = false;
    this.missingProvinces = [];
    this.allProvincesResolved = false;
  }

  getSelectedPlanes(): any[] {
    let ids: string[] = [];
    if (this.tipoImportacion === 'PADRON_MDP') {
      ids = this.step1Form?.value?.planesIds || [];
    } else if (this.tipoImportacion === 'FARMACIAS') {
      ids = this.pharmacyForm?.value?.planesIds || [];
    }
    
    if (!ids || ids.length === 0) {
      return [];
    }
    
    return this.planes.filter(p => p && ids.includes(p._id));
  }

  async processPdf() {
    if (this.step1Form.invalid || !this.selectedFile) {
      this.step1Form.markAllAsTouched();
      Swal.fire('Atención', 'Complete todos los campos y seleccione un archivo', 'warning');
      return;
    }

    const { signoLocalidadId, signoGerenciadoraId, signoZonaId } = this.step1Form.value;

    // Guardar referencias para usar de fallback en el paso final
    this.resLocalidad = this.localidades.find(l => l._id === signoLocalidadId);
    this.resZona = this.zonas.find(z => z._id === signoZonaId);
    this.resGerenciadora = this.gerenciadoras.find(g => g._id === signoGerenciadoraId);

    this.isProcessingPdf = true;
    Swal.fire({
      title: 'Procesando Padrón',
      text: 'Por favor aguarde, esto puede tardar unos minutos...',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    try {
      const resp = await this.padronesService.processSpecialistPdf(
        this.selectedFile,
        signoLocalidadId,
        signoGerenciadoraId,
        signoZonaId
      );
      Swal.close();
      await this.loadUnmatchedSpecialties();
      this.stepper.next();
    } catch (error) {
      Swal.fire('Error', 'Hubo un error procesando el PDF', 'error');
      console.error(error);
    } finally {
      this.isProcessingPdf = false;
    }
  }

  // --- FARMACIAS FLOW ---

  async processPharmacyExcel() {
    if (this.pharmacyForm.invalid || !this.pharmacyFile) {
      this.pharmacyForm.markAllAsTouched();
      Swal.fire('Atención', 'Complete todos los campos y seleccione un archivo Excel (.xlsx, .xls)', 'warning');
      return;
    }

    const { especialidadId, rubroId, gerenciadoraId } = this.pharmacyForm.value;

    this.isProcessingPharmacy = true;
    Swal.fire({
      title: 'Procesando Farmacias',
      html: 'Subiendo archivo y procesando datos...',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    try {
      // 1. Subir el archivo y registrar el inicio del Job
      const resp = await this.padronFarmaciasService.processPharmacyExcel(
        this.pharmacyFile,
        especialidadId,
        rubroId,
        gerenciadoraId
      );

      const jobId = resp.jobId;
      if (!jobId) {
        throw new Error('No se recibió un identificador de proceso (Job ID) del servidor.');
      }

      // 2. Bucle de polling para actualizar el progreso
      let jobFinished = false;
      while (!jobFinished) {
        await new Promise(resolve => setTimeout(resolve, 1000));
        
        const statusResp = await this.padronFarmaciasService.getPharmacyImportStatus(jobId);
        if (!statusResp || !statusResp.status) {
          throw new Error('No se pudo obtener el estado de la importación.');
        }

        const job = statusResp.status;
        if (job.status === 'processing') {
          const processed = job.processed || 0;
          const total = job.total || 0;
          const percentage = total > 0 ? Math.round((processed / total) * 100) : 0;
          
          Swal.update({
            html: `Procesando datos en el servidor... <br> <b>Progreso: ${processed} de ${total} filas (${percentage}%)</b>`
          });
        } else if (job.status === 'completed') {
          jobFinished = true;
          this.pharmacyImportResult = job.result;
          this.pharmacyDuplicates = job.result?.duplicates || [];

          Swal.fire('¡Éxito!', `Se han importado ${this.pharmacyImportResult.count || 0} farmacias correctamente.${this.pharmacyDuplicates.length > 0 ? ` Se detectaron ${this.pharmacyDuplicates.length} duplicados.` : ''}`, 'success');
          
          await this.checkMissingProvinces();
          this.stepper.next();
        } else if (job.status === 'failed') {
          jobFinished = true;
          const errorMsg = job.errors && job.errors.length > 0 ? job.errors.join('<br>') : 'Error interno en el servidor.';
          Swal.fire({
            title: 'Error de Importación',
            html: `Ocurrió un error al procesar el Excel:<br><br><span class="text-danger small">${errorMsg}</span>`,
            icon: 'error'
          });
        }
      }

    } catch (error: any) {
      Swal.fire('Error', error.message || 'Hubo un error procesando el archivo Excel', 'error');
      console.error(error);
    } finally {
      this.isProcessingPharmacy = false;
    }
  }

  get selectedPharmacyGerenciadoraName(): string {
    const id = this.pharmacyForm?.value?.gerenciadoraId;
    const found = this.gerenciadoras?.find(g => g._id === id);
    return found ? found.nombre : '';
  }

  async confirmDeletePharmacies() {
    let rubroId = this.pharmacyForm.value.rubroId;
    if (!rubroId && this.rubros && this.rubros.length > 0) {
      const farmaciaRubro = this.rubros.find(r => r.concepto && r.concepto.toUpperCase().includes('FARMACIA'));
      if (farmaciaRubro) {
        rubroId = farmaciaRubro._id;
      }
    }

    const { isConfirmed } = await Swal.fire({
      title: '¿Confirmar eliminación crítica?',
      text: 'ATENCIÓN: esta acción eliminará TODOS los centros médicos con rubro FARMACIA de la base de datos. Esta operación solo debe realizarse UNA ÚNICA VEZ al inicio del proceso de reemplazo y NO se puede deshacer.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, eliminar todas (Una única vez)',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6'
    });

    if (!isConfirmed) return;

    this.isDeletingPharmacies = true;
    Swal.fire({
      title: 'Eliminando Farmacias',
      text: 'Por favor aguarde...',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    try {
      const resp = await this.padronFarmaciasService.deletePharmacies(rubroId);
      const total = resp?.deletedCount || 0;
      Swal.fire('¡Éxito!', `Se han eliminado todas las farmacias (${total} en total).`, 'success');
    } catch (error) {
      console.error(error);
      Swal.fire('Error', 'Hubo un error al eliminar las farmacias.', 'error');
    } finally {
      this.isDeletingPharmacies = false;
    }
  }

  async checkMissingProvinces() {
    this.isCheckingProvinces = true;
    try {
      const allPharmacies = await this.padronFarmaciasService.getPharmacyAllRecords();
      this.provincias = await this.provinciaService.findAll();
      
      const provSet = new Set<string>();
      allPharmacies.forEach(p => {
         if (p.provincia && p.provincia.trim()) {
            provSet.add(p.provincia.trim());
         }
      });

      const normalize = (s: string) => (s || '').normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/\s+/g, ' ').trim();
      const existingNames = this.provincias.map(l => normalize(l.nombre));
      
      this.missingProvinces = [];
      provSet.forEach(prov => {
          const normProv = normalize(prov);
          if (!existingNames.includes(normProv)) {
              this.missingProvinces.push(prov);
          }
      });

      this.missingProvinces.sort();
      this.allProvincesResolved = this.missingProvinces.length === 0;
    } catch (error) {
      console.error(error);
      Swal.fire('Error', 'No se pudieron verificar las provincias.', 'error');
    } finally {
      this.isCheckingProvinces = false;
    }
  }

  async createNewProvince(provName: string) {
    let optionsHtml = `<option value="">Seleccione una provincia...</option>`;
    this.provincias.forEach(p => {
        optionsHtml += `<option value="${p.nombre}">${p.nombre}</option>`;
    });

    const { value: formValues } = await Swal.fire({
      title: 'Resolver Provincia',
      html: `
        <div class="text-left mb-3">
          <strong>Provincia en archivo:</strong> <span class="text-danger">${provName}</span>
        </div>
        <div class="form-group text-left">
          <label class="small font-weight-bold">¿Qué desea hacer?</label>
          <div class="custom-control custom-radio mb-2">
            <input type="radio" id="radio-asociar" name="provinciaAction" value="asociar" class="custom-control-input" checked onchange="document.getElementById('div-asociar').style.display='block'; document.getElementById('div-crear').style.display='none';">
            <label class="custom-control-label" for="radio-asociar">Asociar a una existente</label>
          </div>
          <div class="custom-control custom-radio">
            <input type="radio" id="radio-crear" name="provinciaAction" value="crear" class="custom-control-input" onchange="document.getElementById('div-asociar').style.display='none'; document.getElementById('div-crear').style.display='block';">
            <label class="custom-control-label" for="radio-crear">Crear como nueva</label>
          </div>
        </div>

        <div id="div-asociar" class="form-group text-left mt-3">
          <label class="small font-weight-bold">Seleccione Provincia Existente <span class="text-danger">*</span></label>
          <select id="swal-input-prov-select" class="swal2-select" style="display: flex; width: 100%; font-size: 14px; padding: 5px; margin: 0;">
            ${optionsHtml}
          </select>
        </div>

        <div id="div-crear" class="form-group text-left mt-3" style="display: none;">
          <label class="small font-weight-bold">Nombre de la Nueva Provincia <span class="text-danger">*</span></label>
          <input id="swal-input-prov-nombre" class="swal2-input" value="${provName}" style="display: flex; width: 100%; font-size: 14px; padding: 5px; height: 40px; margin: 0;">
        </div>
      `,
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: 'Guardar',
      cancelButtonText: 'Cancelar',
      preConfirm: () => {
        const action = (document.getElementById('radio-asociar') as HTMLInputElement).checked ? 'asociar' : 'crear';
        if (action === 'asociar') {
            const select = document.getElementById('swal-input-prov-select') as HTMLSelectElement;
            if (!select.value) {
                Swal.showValidationMessage('Debe seleccionar una provincia existente');
                return false;
            }
            return { action: 'asociar', nombre: select.value };
        } else {
            const input = document.getElementById('swal-input-prov-nombre') as HTMLInputElement;
            if (!input.value.trim()) {
                Swal.showValidationMessage('El nombre de la nueva provincia es obligatorio');
                return false;
            }
            return { action: 'crear', nombre: input.value.trim() };
        }
      }
    });

    if (formValues) {
      Swal.fire({
        title: formValues.action === 'crear' ? 'Creando Provincia...' : 'Asociando Provincia...',
        allowOutsideClick: false,
        didOpen: () => { Swal.showLoading(); }
      });
 
      try {
        if (formValues.action === 'crear') {
            const newProv = {
              nombre: formValues.nombre,
              letra: ''
            };
            await this.provinciaService.createProvinciaSilent(newProv);
            await this.padronFarmaciasService.updateTemporalProvinceName(provName, formValues.nombre);
        } else {
            await this.padronFarmaciasService.updateTemporalProvinceName(provName, formValues.nombre);
        }

        Swal.fire({ icon: 'success', title: formValues.action === 'crear' ? 'Provincia creada' : 'Provincia asociada', timer: 1500, showConfirmButton: false });
        
        this.createdProvincesSummary.push(formValues.action === 'crear' ? `${formValues.nombre} (Creada)` : `${provName} → ${formValues.nombre} (Asociada)`);

        this.missingProvinces = this.missingProvinces.filter(p => p !== provName);
        this.provincias = await this.provinciaService.findAll();
        this.allProvincesResolved = this.missingProvinces.length === 0;
      } catch (error) {
         console.error(error);
         Swal.fire('Error', 'Hubo un error al resolver la provincia.', 'error');
      }
    }
  }

  nextToLocalidadesFarmacias() {
    if (!this.allProvincesResolved) {
      Swal.fire('Atención', 'Debe resolver todas las provincias faltantes antes de continuar', 'warning');
      return;
    }
    
    Swal.fire({
      title: 'Verificando Localidades...',
      allowOutsideClick: false,
      didOpen: () => { Swal.showLoading(); }
    });

    this.checkMissingLocalities().then(() => {
       Swal.close();
       this.stepper.next();
    });
  }

  async checkMissingLocalities() {
    this.isCheckingLocalities = true;
    try {
      const allPharmacies = await this.padronFarmaciasService.getPharmacyAllRecords();
      // Refrescar catálogo local de localidades
      this.localidades = await this.localidadService.getLocalidades();
      
      const normalize = (s: string) => (s || '').normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/\s+/g, ' ').trim();
      const existingNames = this.localidades.map(l => normalize(l.nombre));
      
      const missingLocsMap = new Map<string, { localidad: string, provincia: string, codigoPostal: string, farmaciaDemo: string }>();

      allPharmacies.forEach(p => {
         if (p.localidad && p.localidad.trim()) {
            const locName = p.localidad.trim();
            const normLoc = normalize(locName);
            if (!existingNames.includes(normLoc) && !missingLocsMap.has(normLoc)) {
                missingLocsMap.set(normLoc, {
                   localidad: locName,
                   provincia: p.provincia || '-',
                   codigoPostal: p.codigoPostal || '-',
                   farmaciaDemo: p.farmacia || '-'
                });
            }
         }
      });

      this.missingLocalities = Array.from(missingLocsMap.values());
      this.missingLocalities.sort((a, b) => a.localidad.localeCompare(b.localidad));
      this.allLocalitiesResolved = this.missingLocalities.length === 0;
    } catch (error) {
      console.error(error);
      Swal.fire('Error', 'No se pudieron verificar las localidades.', 'error');
    } finally {
      this.isCheckingLocalities = false;
    }
  }

  async createNewLocality(locName: string) {
    const allPharmacies = await this.padronFarmaciasService.getPharmacyAllRecords();
    const normalize = (s: string) => (s || '').normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/\s+/g, ' ').trim();
    
    const pharmacyMatch = allPharmacies.find(p => normalize(p.localidad) === normalize(locName));
    const excelProvinciaName = pharmacyMatch ? pharmacyMatch.provincia : '';
    
    let preselectedProvinciaId = '';
    if (excelProvinciaName) {
        const normExcelProv = normalize(excelProvinciaName);
        const matchProv = this.provincias.find(p => normalize(p.nombre) === normExcelProv);
        if (matchProv) {
            preselectedProvinciaId = matchProv._id;
        }
    }

    let htmlForm = `
      <div class="text-left mb-3">
        <strong>Localidad a crear:</strong> ${locName}
      </div>
      <div class="form-group text-left mt-3">
        <label class="small font-weight-bold">Seleccione Provincia <span class="text-danger">*</span></label>
        <select id="swal-input-provincia" class="swal2-select" style="display: flex; width: 100%; font-size: 14px; padding: 5px;">
          <option value="" disabled ${!preselectedProvinciaId ? 'selected' : ''}>Seleccione provincia...</option>
          ${this.provincias.map(p => `<option value="${p._id}" ${p._id === preselectedProvinciaId ? 'selected' : ''}>${p.nombre}</option>`).join('')}
        </select>
      </div>
      <div class="form-group text-left mt-3">
        <label class="small font-weight-bold">Seleccione Zona <span class="text-danger">*</span></label>
        <select id="swal-input-zona" class="swal2-select" style="display: flex; width: 100%; font-size: 14px; padding: 5px;">
          <option value="" disabled selected>Seleccione zona...</option>
          ${this.zonas.map(z => `<option value="${z._id}">${z.concepto}</option>`).join('')}
        </select>
      </div>
    `;

    const { value: formValues } = await Swal.fire({
      title: 'Crear Localidad Faltante',
      html: htmlForm,
      focusConfirm: false,
      showCancelButton: true,
      preConfirm: () => {
        const provSelect = document.getElementById('swal-input-provincia') as HTMLSelectElement;
        const zonaSelect = document.getElementById('swal-input-zona') as HTMLSelectElement;
        if (!provSelect.value || !zonaSelect.value) {
          Swal.showValidationMessage('Debe seleccionar provincia y zona obligatoriamente');
          return false;
        }
        return { provinciaId: provSelect.value, zonaId: zonaSelect.value };
      }
    });

    if (formValues) {
      Swal.fire({
        title: 'Creando Localidad...',
        allowOutsideClick: false,
        didOpen: () => { Swal.showLoading(); }
      });
 
      try {
        const newLoc = {
          nombre: locName.trim(),
          provincia: { _id: formValues.provinciaId }, // ObjectId
          zona: { _id: formValues.zonaId }, // ObjectId
          activo: true
        };
        
        await this.padronFarmaciasService.createLocalidadSilent(newLoc);
        Swal.fire({ icon: 'success', title: 'Localidad creada con éxito', timer: 1500, showConfirmButton: false });
        
        this.createdLocalitiesSummary.push(locName.trim());

        this.missingLocalities = this.missingLocalities.filter(l => l.localidad !== locName);
        
        // Recargar el catálogo local
        this.localidades = await this.localidadService.getLocalidades();
        this.allLocalitiesResolved = this.missingLocalities.length === 0;
      } catch (error) {
         console.error(error);
         Swal.fire('Error', 'Hubo un error al crear la localidad.', 'error');
      }
    }
  }

  async massCreateLocalities() {
    const confirm = await Swal.fire({
      title: 'Creación Masiva',
      text: `¿Desea crear automáticamente las ${this.missingLocalities.length} localidades faltantes y asignarles como zona su provincia correspondiente?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, automatizar todo',
      cancelButtonText: 'Cancelar'
    });

    if (!confirm.isConfirmed) return;

    Swal.fire({
      title: 'Creando...',
      html: 'Generando zonas y localidades, por favor espere.',
      allowOutsideClick: false,
      didOpen: () => { Swal.showLoading(); }
    });

    try {
      const zonasNode = await this.catalogoService.getFindByKey(EntidadesKeys.ZONAS);
      const parentZonaId = zonasNode._id || (zonasNode as any).$oid;
      let createdCount = 0;

      for (const m of [...this.missingLocalities]) {
        // 1. Encontrar Provincia original validada
        const normProvName = (m.provincia || '').trim().toUpperCase();
        const prov = this.provincias.find(p => (p.nombre || '').trim().toUpperCase() === normProvName);
        
        const provinciaId = prov ? prov._id : null;
        if (!provinciaId) continue; // Si no encuentra provincia, salta

        // 2. Buscar Zona por nombre de provincia o crearla
        let zona = this.zonas.find(z => (z.concepto || '').trim().toUpperCase() === normProvName);
        let zonaId = zona ? zona._id : null;

        if (!zonaId) {
          const newZona = {
            concepto: normProvName,
            key: normProvName.replace(/\s+/g, '_').toUpperCase(),
            parent_id: parentZonaId,
            esDirectorio: false,
            activo: true
          };
          const createdZona: any = await this.catalogoService.post(newZona as any);
          if (createdZona) {
            zonaId = createdZona._id;
            this.zonas.push(createdZona); // Cache local para que no vuelva a crearla
          }
        }

        // 3. Crear la localidad referenciando provincia y zona
        if (zonaId && provinciaId) {
          const newLoc = {
            nombre: m.localidad.trim(),
            provincia: { _id: provinciaId },
            zona: { _id: zonaId },
            activo: true
          };
          await this.padronFarmaciasService.createLocalidadSilent(newLoc);
          
          this.createdLocalitiesSummary.push(`${m.localidad.trim()} (Zona autogenerada: ${normProvName})`);
          this.missingLocalities = this.missingLocalities.filter(l => l.localidad !== m.localidad);
          createdCount++;
        }
      }

      this.localidades = await this.localidadService.getLocalidades();
      this.allLocalitiesResolved = this.missingLocalities.length === 0;

      Swal.fire({
        icon: 'success',
        title: 'Proceso Masivo Completado',
        text: `Se crearon ${createdCount} localidades y se asignaron sus zonas correctamente.`
      });

    } catch (error) {
      console.error(error);
      Swal.fire('Error', 'Ocurrió un problema en la automatización. Intente resolver manualmente.', 'error');
    }
  }

  async nextToGeolocationFarmacias() {
    if (!this.allLocalitiesResolved) {
      const { isConfirmed } = await Swal.fire({
        title: 'Localidades sin resolver',
        text: 'Hay localidades que no existen en el sistema. Las farmacias que pertenezcan a estas localidades NO se importarán. ¿Desea continuar de todos modos?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, continuar',
        cancelButtonText: 'Cancelar'
      });
      if (!isConfirmed) return;
    }
    this.stepper.next();
  }

  async geolocateFarmacias() {
    this.isProcessingPharmacy = true;
    Swal.fire({
      title: 'Geolocalizando Farmacias',
      text: 'Este proceso puede tardar unos minutos...',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    try {
      const res = await this.padronFarmaciasService.geolocateFarmacias();
      Swal.fire({
        title: 'Geolocalización Completada',
        icon: 'success',
        html: `
          <div class="text-left">
            <p>Geolocalizadas: <b>${res.geolocated || 0}</b></p>
            <p>Fallidas: <b>${res.failed || 0}</b></p>
          </div>
        `
      });
    } catch (error) {
      Swal.fire('Error', 'Hubo un error en el proceso de geolocalización', 'error');
      console.error(error);
    } finally {
      this.isProcessingPharmacy = false;
    }
  }

  // --- STEP 2 ---

  async loadUnmatchedSpecialties() {
    try {
      this.unmatchedSpecialties = await this.padronesService.getUnmatchedSpecialties();
      this.checkSpecialtiesResolved();
    } catch (error) {
      console.error(error);
    }
  }

  checkSpecialtiesResolved() {
    this.allSpecialtiesResolved = this.unmatchedSpecialties.length === 0;
    this.cdr.detectChanges();
  }

  async mapSpecialty(item: any, selectedEspecId: string) {
    if (!selectedEspecId) return;
    
    // Buscar el rubro de esa especialidad
    const catEspec = this.catalogoEspecialidades.find(e => e._id === selectedEspecId);
    const rubroId = catEspec?.properties?.rubro || '';

    try {
      await this.padronesService.updateSpecialtyMapping(item.especialidad, selectedEspecId, rubroId);
      Swal.fire({ icon: 'success', title: 'Mapeada correctamente', timer: 1000, showConfirmButton: false });
      // Remover de la lista
      this.unmatchedSpecialties = this.unmatchedSpecialties.filter(u => u.especialidad !== item.especialidad);
      this.checkSpecialtiesResolved();
    } catch (error) {
       Swal.fire('Error', 'No se pudo mapear la especialidad', 'error');
    }
  }

  async createNewSpecialty(item: any) {
    if (!this.specialtyParentId) {
       Swal.fire('Error', 'No se encontró el ID padre de especialidades. Recargue la página.', 'error');
       return;
    }

    // Preparar opciones de rubro para Swal
    const inputOptions: {[key: string]: string} = {};
    this.rubros.forEach(r => {
       inputOptions[r._id] = r.concepto;
    });

    const { value: rubroId } = await Swal.fire({
      title: 'Crear Nueva Especialidad',
      text: `Seleccione el rubro para: ${item.especialidad}`,
      input: 'select',
      inputOptions: inputOptions,
      inputPlaceholder: 'Seleccione un rubro...',
      showCancelButton: true,
      inputValidator: (value) => {
        return new Promise((resolve) => {
          if (value) {
            resolve(null);
          } else {
            resolve('Debe seleccionar un rubro');
          }
        });
      }
    });

    if (rubroId) {
      Swal.fire({
        title: 'Creando...',
        allowOutsideClick: false,
        didOpen: () => { Swal.showLoading(); }
      });
 
      try {
        // Ejecutar creación y mapeo en un solo paso en el backend para mayor confiabilidad
        const newSpec: any = await this.padronesService.createAndMapSpecialty(
          item.especialidad, 
          this.specialtyParentId, 
          rubroId
        );
 
        if (newSpec && newSpec._id) {
           Swal.fire({ icon: 'success', title: 'Creada y vinculada con éxito', timer: 1500, showConfirmButton: false });
           
           // Remover de la lista
           this.unmatchedSpecialties = this.unmatchedSpecialties.filter(u => u.especialidad !== item.especialidad);
           this.checkSpecialtiesResolved();
           
           // Actualizar catalogo local
           this.catalogoEspecialidades.push(newSpec);
           this.catalogoEspecialidades.sort((a,b) => a.concepto.localeCompare(b.concepto));
        } else {
           throw new Error('No se recibió la confirmación del ID');
        }
      } catch (error) {
         console.error(error);
         Swal.fire('Error', 'Hubo un error al crear la especialidad en el servidor. Verifique logs.', 'error');
      }
    }
  }

  nextToGeolocation() {
    if (this.tipoImportacion === 'PADRON_MDP' && !this.allSpecialtiesResolved) {
      Swal.fire('Atención', 'Debe resolver todas las especialidades antes de continuar', 'warning');
      return;
    }
    this.stepper.next();
    if (this.tipoImportacion === 'FARMACIAS') {
      this.startGeolocationFarmacias();
    } else {
      this.startGeolocation()
    }
  }

  // --- STEP 3 ---

  async startGeolocation() {
    this.isGeolocating = true;
    this.unmatchedAddresses = [];
    this.geoProgress = 0;
    this.isGeoCancelled = false;

    try {
      // 1. Obtener cantidad inicial de pendientes
      const pending = await this.padronesService.getUnmatchedAddresses();
      this.geoInitialCount = pending.length;
      this.geoCurrentCount = this.geoInitialCount;

      if (this.geoInitialCount === 0) {
          Swal.fire('Info', 'No hay direcciones pendientes de geolocalización', 'info');
          this.isGeolocating = false;
          return;
      }

      // 2. Mostrar Swal con aviso y botón cancelar
      const swalInstance = Swal.fire({
        title: 'Geolocalizando',
        html: `
          <div id="swal-geo-content">Iniciando proceso... <br> <b>0%</b> completado</div>
          <div id="swal-geo-current" class="mt-2 text-primary small font-weight-bold" style="min-height: 20px;"></div>
          <div id="swal-geo-status" class="small" style="min-height: 20px;"></div>
          <div class="mt-3 p-2 bg-light border rounded small text-muted">
            <i class="fas fa-info-circle text-info"></i> El proceso respeta los límites de velocidad de los mapas (Nominatim).<br><b>No cierre esta pestaña</b> hasta finalizar el proceso.
          </div>
          <div class="mt-3 spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
            <span class="sr-only">Loading...</span>
          </div>
        `,
        allowOutsideClick: false,
        showConfirmButton: false,
        showCancelButton: true,
        cancelButtonText: 'Interrumpir Proceso',
        cancelButtonColor: '#d33',
      });

      // 3. Manejar la cancelación por el usuario
      swalInstance.then((result) => {
        if (result.dismiss === Swal.DismissReason.cancel) {
          this.isGeoCancelled = true;
          this.isGeolocating = false;
          Swal.fire({
            title: 'Proceso Interrumpido',
            text: "Se ha detenido el proceso de geolocalización.",
            icon: 'warning',
            confirmButtonText: 'Entendido'
          });
        }
      });

      let geolocalizados = 0;
      let fallidos = 0;

      // 4. Procesar secuencialmente con feedback en tiempo real
      for (let i = 0; i < pending.length; i++) {
        if (this.isGeoCancelled) break;
        
        const addr = pending[i];
        
        // Actualizar UI Progress
        const progress = Math.round((i / this.geoInitialCount) * 100);
        const content = document.getElementById('swal-geo-content');
        const currentLabel = document.getElementById('swal-geo-current');
        
        if (content) content.innerHTML = `Procesando direcciones... <br> <b>${progress}%</b> (${i}/${this.geoInitialCount})`;
        if (currentLabel) currentLabel.innerText = `Actual: ${addr.domicilio}`;
        const statusLabel = document.getElementById('swal-geo-status');
        if (statusLabel) statusLabel.innerHTML = '<span class="text-muted small">Procesando...</span>';

        // Llamada individual al backend con reintentos para Rate Limit
        let retryCount = 0;
        let success = false;
        
        while (retryCount < 2 && !success && !this.isGeoCancelled) {
          try {
            const res = await this.padronesService.geolocateOneAddress(addr.domicilio);
            if (res && res.success) {
              geolocalizados++;
              success = true;
              if (statusLabel) statusLabel.innerHTML = '<i class="fas fa-check-circle text-success pulse"></i> <span class="text-success font-weight-bold">¡Geolocalizado con éxito!</span>';
            } else {
              fallidos++;
              success = true; 
              if (statusLabel) statusLabel.innerHTML = '<i class="fas fa-exclamation-triangle text-danger"></i> <span class="text-danger">No se pudo geolocalizar (verifique dirección)</span>';
            }
          } catch (err) {
            if (err.status === 429) {
              retryCount++;
              if (retryCount < 2) {
                if (statusLabel) statusLabel.innerHTML = `<i class="fas fa-clock text-warning"></i> <span class="text-danger">Límite alcanzado. Reintentando en 10s...</span>`;
                await new Promise(resolve => setTimeout(resolve, 10000));
              } else {
                fallidos++;
                success = true; 
                if (statusLabel) statusLabel.innerHTML = '<i class="fas fa-times-circle text-danger"></i> <span class="text-danger">Error: Límite de intentos agotado.</span>';
              }
            } else {
              fallidos++;
              success = true;
              if (statusLabel) statusLabel.innerHTML = '<i class="fas fa-bug text-danger"></i> <span class="text-danger">Error inesperado en este registro.</span>';
            }
          }
        }

        // Delay para respetar rate limit de Nominatim
        if (i < pending.length - 1 && !this.isGeoCancelled) {
           await new Promise(resolve => setTimeout(resolve, 2000));
        }
      }
      
      if (!this.isGeoCancelled) {
        clearInterval(this.geoInterval);
        this.unmatchedAddresses = await this.padronesService.getUnmatchedAddresses();
        Swal.close();

        // Métricas detalladas de geolocalización
        const totalAnalizados = this.geoInitialCount;
        const noGeolocalizados = this.unmatchedAddresses.length;
        const geolocalizados = totalAnalizados - noGeolocalizados;

        const metricsHtml = `
          <div class="text-left">
            <div class="p-3 mb-3 border rounded bg-light">
              <p class="mb-2" style="font-size: 1.05rem;">
                <i class="fas fa-chart-bar text-primary mr-2"></i>
                Se analizaron <b>${totalAnalizados}</b> registros.
              </p>
              <p class="mb-2 text-success" style="font-size: 1.05rem;">
                <i class="fas fa-map-marker-alt mr-2"></i>
                <b>${geolocalizados}</b> direcciones fueron geolocalizadas correctamente.
              </p>
              <p class="mb-0 ${noGeolocalizados > 0 ? 'text-danger' : 'text-success'}" style="font-size: 1.05rem;">
                <i class="fas fa-exclamation-triangle mr-2"></i>
                <b>${noGeolocalizados}</b> no pudieron ser ubicadas geográficamente.
              </p>
            </div>
            <div class="alert alert-info border-info mb-0 small">
              <i class="fas fa-info-circle mr-1"></i>
              Esto no impide crear los centros. Puede continuar.
            </div>
          </div>
        `;

        Swal.fire({
          title: 'Geolocalización Completada',
          icon: noGeolocalizados > 0 ? 'warning' : 'success',
          html: metricsHtml,
          confirmButtonText: 'Entendido, Continuar'
        });
      }
      
    } catch (error) {
      if (this.geoInterval) clearInterval(this.geoInterval);
      if (!this.isGeoCancelled) {
        Swal.fire('Aviso', 'Finalizado con posibles fallos. Verifique direcciones no encontradas.', 'warning');
        this.unmatchedAddresses = await this.padronesService.getUnmatchedAddresses().catch(()=>[]);
      }
    } finally {
      if (!this.isGeoCancelled) this.isGeolocating = false;
    }
  }

  async startGeolocationFarmacias() {
    this.isGeolocating = true;
    this.unmatchedAddresses = []; // Reuse this for displaying "not found" if needed
    this.geoProgress = 0;
    this.isGeoCancelled = false;

    try {
      // 0. Obtener resumen inicial para poblar UI
      this.pharmacyImportResult = await this.padronFarmaciasService.getPharmacySummary();
      this.cdr.detectChanges();

      // 1. Obtener cantidad inicial de pendientes (usando el servicio de farmacias)
      const pending = await this.padronFarmaciasService.getPharmacyUnmatchedAddresses();
      this.geoInitialCount = pending.length;
      this.geoCurrentCount = 0;

      if (this.geoInitialCount === 0) {
          Swal.fire('Info', 'No hay farmacias pendientes de geolocalización', 'info');
          this.isGeolocating = false;
          return;
      }

      // 2. Mostrar Swal (Mismo diseño que MDP)
      const swalInstance = Swal.fire({
        title: 'Geolocalizando',
        html: `
          <div id="swal-geo-content">Iniciando proceso... <br> <b>0%</b> completado</div>
          <div id="swal-geo-current" class="mt-2 text-primary small font-weight-bold" style="min-height: 20px;"></div>
          <div id="swal-geo-status" class="small" style="min-height: 20px;"></div>
          <div class="mt-3 p-2 bg-light border rounded small text-muted">
            <i class="fas fa-info-circle text-info"></i> El proceso respeta los límites de velocidad de los mapas (Nominatim).<br><b>No cierre esta pestaña</b> hasta finalizar el proceso.
          </div>
          <div class="mt-3 spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
            <span class="sr-only">Loading...</span>
          </div>
        `,
        allowOutsideClick: false,
        showConfirmButton: false,
        showCancelButton: true,
        cancelButtonText: 'Interrumpir Proceso',
        cancelButtonColor: '#d33',
      });

      swalInstance.then((result) => {
        if (result.dismiss === Swal.DismissReason.cancel) {
          this.isGeoCancelled = true;
          this.isGeolocating = false;
          Swal.fire('Proceso Interrumpido', "Se ha detenido el proceso de geolocalización de farmacias.", 'warning');
        }
      });

      // 3. Procesar secuencialmente
      for (let i = 0; i < pending.length; i++) {
        if (this.isGeoCancelled) break;
        
        const farmacia = pending[i];
        const progress = Math.round((i / this.geoInitialCount) * 100);
        
        const content = document.getElementById('swal-geo-content');
        const currentLabel = document.getElementById('swal-geo-current');
        const statusLabel = document.getElementById('swal-geo-status');
        
        if (content) content.innerHTML = `Procesando farmacias... <br> <b>${progress}%</b> (${i}/${this.geoInitialCount})`;
        if (currentLabel) currentLabel.innerText = `Actual: ${farmacia.farmacia} (${farmacia.domicilio})`;
        if (statusLabel) statusLabel.innerHTML = '<span class="text-muted small">Consultando coordenadas...</span>';

        let retryCount = 0;
        let success = false;
        
        while (retryCount < 2 && !success && !this.isGeoCancelled) {
          try {
            const res = await this.padronFarmaciasService.geolocateOnePharmacy(farmacia._id);
            if (res && res.success) {
              success = true;
              if (statusLabel) statusLabel.innerHTML = '<i class="fas fa-check-circle text-success pulse"></i> <span class="text-success font-weight-bold">¡Ubicada con éxito!</span>';
            } else {
              success = true; 
              if (statusLabel) statusLabel.innerHTML = '<i class="fas fa-exclamation-triangle text-danger"></i> <span class="text-danger">No se encontró la ubicación.</span>';
            }
          } catch (err) {
            if (err.status === 429) {
              retryCount++;
              if (retryCount < 2) {
                if (statusLabel) statusLabel.innerHTML = `<i class="fas fa-clock text-warning"></i> <span class="text-danger">Límite alcanzado. Reintentando en 10s...</span>`;
                await new Promise(resolve => setTimeout(resolve, 10000));
              } else {
                success = true; 
                if (statusLabel) statusLabel.innerHTML = '<i class="fas fa-times-circle text-danger"></i> <span class="text-danger">Error: Límite agotado.</span>';
              }
            } else {
              success = true;
              if (statusLabel) statusLabel.innerHTML = '<i class="fas fa-bug text-danger"></i> <span class="text-danger">Error técnico en este registro.</span>';
            }
          }
        }

        if (i < pending.length - 1 && !this.isGeoCancelled) {
           await new Promise(resolve => setTimeout(resolve, 1200)); // Delay conservador
        }
      }
      
      if (!this.isGeoCancelled) {
        Swal.close();
        // Obtener resumen actualizado
        const sum = await this.padronFarmaciasService.getPharmacySummary();
        
        const metricsHtml = `
          <div class="text-center">
            <p class="mb-3 font-weight-bold">Todos los registros de farmacias fueron procesados y ya podés continuar con la creación de los centros médicos.</p>
            <div class="text-left p-3 border rounded bg-light small">
              <p class="mb-2"><i class="fas fa-pills text-primary mr-2"></i> Farmacias analizadas: <b>${sum.totalRecords}</b></p>
              <p class="mb-2 text-success"><i class="fas fa-map-marked-alt mr-2"></i> Geolocalizadas: <b>${sum.geolocatedCenters}</b></p>
              <p class="mb-0 ${sum.unmatchedCenters > 0 ? 'text-danger' : 'text-success'}"><i class="fas fa-search-location mr-2"></i> Sin ubicación: <b>${sum.unmatchedCenters}</b></p>
            </div>
          </div>
        `;

        await Swal.fire({
          title: 'Geolocalización finalizada correctamente',
          icon: sum.unmatchedCenters > 0 ? 'warning' : 'success',
          html: metricsHtml,
          confirmButtonText: 'Entendido, Continuar',
          allowOutsideClick: false
        });
        
        this.pharmacyImportResult = sum; // Guardar para Step 4 UI
      }
      
    } catch (error) {
       console.error(error);
       Swal.fire('Error', 'Hubo un problema durante el proceso de geolocalización.', 'error');
    } finally {
      this.isGeolocating = false;
      this.cdr.detectChanges();
    }
  }

  async finishProcess() {
    try {
      Swal.fire({ title: 'Cargando resumen...', allowOutsideClick: false, didOpen: () => Swal.showLoading() });
      const summary = await this.padronesService.getSummary();
      Swal.close();

      const htmlContent = `
        <div class="text-left">
          <p>Se han procesado: <b>${summary.totalRecords}</b> registros de profesionales.</p>
          <p>Se crearán un total de: <b>${summary.totalCenters}</b> Locales Médicos (agrupados por domicilio).</p>
          <hr>
          <ul class="list-unstyled">
            <li><i class="fas fa-check-circle text-success"></i> Direcciones con mapa: <b>${summary.geolocatedCenters}</b></li>
            <li><i class="fas fa-exclamation-triangle text-warning"></i> Direcciones sin mapa: <b>${summary.unmatchedCenters}</b></li>
          </ul>
          <p class="small text-muted mt-3"><i>* Cada local contendrá todas las especialidades disponibles en esa dirección física.</i></p>
        </div>
      `;

      if (this.showUnifyButton) {
        Swal.fire({
            title: '¡Resumen Final de Importación!',
            html: htmlContent,
            icon: 'success',
            confirmButtonText: 'Finalizar y Regresar al Inicio',
            allowOutsideClick: false
        }).then(() => {
            window.location.reload();
        });
      } else {
        Swal.fire({
            title: '¿Confirmar creación de Centros?',
            html: htmlContent,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, crear centros'
        }).then((result) => {
            if (result.isConfirmed) {
                this.migrateToCentros();
            }
        });
      }
    } catch (error) {
       Swal.fire('Error', 'No se pudo obtener el resumen del padrón', 'error');
    }
  }

  formatPhone(phone: string, defaultAreaCode: string): string {
    // 1. Limpieza radical: SOLO números
    let cleaned = (phone || '').replace(/[^\d]/g, '').trim();
    if (!cleaned || cleaned === '0' || cleaned.length < 7) return '';

    // 2. Manejo de 0800/0810 (no agregar área)
    if (cleaned.startsWith('0800') || cleaned.startsWith('0810')) {
      return cleaned.replace(/^(\d{4})(\d{3})(\d{4})$/, '$1-$2-$3');
    }

    // 3. Normalizar código de área
    if (!cleaned.startsWith('0')) {
      if (cleaned.length === 10 && (cleaned.startsWith('11') || cleaned.startsWith('2') || cleaned.startsWith('3'))) {
        cleaned = '0' + cleaned;
      } else if (cleaned.length === 7 || cleaned.length === 8) {
        if (defaultAreaCode) {
          let area = defaultAreaCode.replace(/[^\d]/g, '');
          if (!area.startsWith('0')) area = '0' + area;
          cleaned = area + cleaned;
        }
      }
    }

    // 4. Formateo Visual
    // Celular (estilo 11 2345-6789)
    if (cleaned.startsWith('011') && cleaned.length === 11) {
      return cleaned.substring(1).replace(/^(\d{2})(\d{4})(\d{4})$/, '$1 $2-$3');
    }

    // Fijo (estilo 0223-5487330)
    if (cleaned.startsWith('0') && (cleaned.length === 11 || cleaned.length === 10)) {
       return cleaned.replace(/^(\d{4})(\d+)$/, '$1-$2');
    }

    // Si al menos tiene 7 dígitos lo devolvemos limpio
    return cleaned.length >= 7 ? cleaned : '';
  }

  async migrateToCentros() {
    try {
      this.isMigratingData = true;
      
      const { codigoArea, planesIds } = this.step1Form.value;
      const selectedPlanesIds = planesIds || [];

      // 1. Obtener todos los registros temporales
      const allRecords = await this.padronesService.getAllRecords();
      const getId = (id: any) => (id && typeof id === 'object' && id.$oid) ? id.$oid : id?.toString();

      if (allRecords.length === 0) {
        Swal.fire('Info', 'No hay registros para procesar.', 'info');
        this.isMigratingData = false;
        return;
      }

      // 2. AGRUPAR POR DOMICILIO
      const groupsMap = new Map<string, any[]>();
      allRecords.forEach(rec => {
        const key = `${rec.calle || ''}-${rec.altura || ''}-${getId(rec.signoLocalidad) || ''}`.trim().toUpperCase();
        if (!groupsMap.has(key)) groupsMap.set(key, []);
        groupsMap.get(key).push(rec);
      });

      const totalGroups = groupsMap.size;
      this.geoInitialCount = totalGroups;
      this.geoCurrentCount = 0;
      this.geoProgress = 0;

      // 3. Cargar existentes
      const allExisting = await this.signoCentroMedicoService.getCentroMedicos();

      let centersCreated = 0;
      let centersFailed = 0;
      let centersSkipped = 0;
      const failedRecordsList: any[] = [];

      // 4. Procesar Grupos
      for (const [key, groupRecords] of Array.from(groupsMap.entries())) {
        this.geoCurrentCount++;
        this.geoProgress = Math.round((this.geoCurrentCount / this.geoInitialCount) * 100);

        const first = groupRecords[0];
        let nombreCentro = '';
        
        const normalize = (n: string) => (n || '').trim().replace(/\s*\(C\d+\)\s*$/i, '').toUpperCase();
        const uniqueNormalizedNames = Array.from(new Set(groupRecords.map(r => normalize(r.especialista))));

        if (uniqueNormalizedNames.length === 1) {
          nombreCentro = uniqueNormalizedNames[0];
        } else {
          nombreCentro = `CONSULTORIOS ${first.calle || ''} ${first.altura || ''}`.trim().toUpperCase();
        }

        const currentGerId = getId(first.signoGerenciadora) || this.resGerenciadora?._id;
        
        const normStr = (s: string) => (s || '').trim().toUpperCase();
        const targetName = normStr(nombreCentro);
        const targetCalle = normStr(first.calle || first.domicilio?.split(' ')[0] || '');
        const targetAlt = normStr(first.altura || '0');

        const exists = allExisting.find(c => {
           const gId = getId(c.gerenciadora);
           if (gId !== currentGerId) return false;
           
           const nameMatch = normStr(c.nombre) === targetName;
           const addrMatch = (normStr(c.calle) === targetCalle && normStr(c.altura) === targetAlt);
           
           return nameMatch || addrMatch;
        });

        if (exists) {
           centersSkipped++;
           continue;
        }

        const uniqueEspecIds = new Set<string>();
        const uniqueRubroIds = new Set<string>();
        const uniquePhones = new Set<string>();

        groupRecords.forEach(r => {
          const eId = getId(r.especialidadId);
          const rId = getId(r.rubroId);
          if (eId) uniqueEspecIds.add(eId);
          if (rId) uniqueRubroIds.add(rId);
          
          // Split phones by / , | or whitespace
          const rawPhones = (r.telefono || '').replace(/[\/\|,]/g, ' ').split(/\s+/);
          rawPhones.forEach(rp => {
            const formatted = this.formatPhone(rp, codigoArea);
            if (formatted) uniquePhones.add(formatted);
          });
        });

        const bestCoord = groupRecords.find(r => Number(r.latitud) !== 0) || first;

        const centroMedico: any = {
           nombre: nombreCentro,
           activo: true,
           calle: first.calle || first.domicilio?.split(' ')[0] || 'S/N',
           altura: first.altura || '0',
           pisoDpto: '',
           zona: { _id: first.signoZona || this.resZona?._id },
           localidad: { _id: first.signoLocalidad || this.resLocalidad?._id },
           telefonos: Array.from(uniquePhones).join(', ') || '0',
           celular: '',
           horarios: first.servicio || 'Padrón',
           latitud: Number(bestCoord.latitud) || 0,
           longitud: Number(bestCoord.longitud) || 0,
           rubros: Array.from(uniqueRubroIds).map(id => ({ _id: id })),
           especialidades: Array.from(uniqueEspecIds).map(id => ({ _id: id })),
           planes: selectedPlanesIds.map(id => ({ _id: id })), 
           gerenciadora: { _id: currentGerId }
        };

        try {
           await this.signoCentroMedicoService.createSilent(centroMedico);
           centersCreated++;
        } catch (err: any) {
           console.error('ERROR AL CREAR GRUPO:', nombreCentro, err);
           centersFailed++;
           failedRecordsList.push({
              especialista: nombreCentro,
              domicilio: first.domicilio,
              error: err.message || 'Error API'
           });
        }
      }

      // 5. INFORME FINAL (Con Auditoría de Unificación)
      let finalTitle = '¡Importación Finalizada! 🚀';
      let finalIcon: 'success' | 'warning' | 'error' = 'success';
      
      this.lastGerenciadoraId = this.resGerenciadora?._id;

      // ELIMINADA FASE 6 AUTOMÁTICA POR PETICIÓN USUARIO
      // Se activa opción manual en el UI
      if (this.lastGerenciadoraId) {
        this.showUnifyButton = true;
      }

      // --- AUDITORÍA DE ESPECIALISTAS MULTI-CENTRO (Petición Usuario) ---
      const specialistGroups = new Map<string, any[]>();
      allRecords.forEach(rec => {
        const code = rec.codigo || 'S/C';
        if (!specialistGroups.has(code)) specialistGroups.set(code, []);
        specialistGroups.get(code).push(rec);
      });

      const multiCenterAudit: any[] = [];
      let multiCenterCount = 0;
      let totalInconsistent = 0;

      specialistGroups.forEach((recs, code) => {
        if (code === 'S/C') return;
        
        // Agrupar por domicilio para contar centros reales
        const addressesMap = new Map<string, string>();
        recs.forEach(r => {
           const addrKey = `${r.calle} ${r.altura}`.trim().toUpperCase();
           if (!addressesMap.has(addrKey)) {
              addressesMap.set(addrKey, r.domicilio || addrKey);
           }
        });

        if (addressesMap.size > 1) {
          multiCenterCount++;
          const name = recs[0].especialista.replace(/\s*\(C\d+\)\s*$/i, '').toUpperCase();
          const hasInconsistency = recs.some(r => !getId(r.especialidadId));
          if (hasInconsistency) totalInconsistent++;
          
          multiCenterAudit.push({
            code,
            name,
            centersCount: addressesMap.size,
            centersList: Array.from(addressesMap.values()),
            isValid: !hasInconsistency
          });
        }
      });

      const consolidatedRecordsCount = allRecords.length - totalGroups;
      const unifiedCentersNames: string[] = [];

      // Detectar nombres de grupos que fueron unificados (2 o más registros)
      groupsMap.forEach((recs, key) => {
          if (recs.length > 1) {
              const first = recs[0];
              const normalize = (n: string) => (n || '').trim().replace(/\s*\(C\d+\)\s*$/i, '').toUpperCase();
              const uniqueNormalizedNamesInGroup = Array.from(new Set(recs.map(r => normalize(r.especialista))));
              
              if (uniqueNormalizedNamesInGroup.length === 1) {
                // Es la misma persona (ej: Sabina Valenti o Esteybar Damiani con varias especialidades)
                unifiedCentersNames.push(`${uniqueNormalizedNamesInGroup[0]} <span class="text-muted">(unificó ${recs.length} registros como C1, C2...)</span>`);
              } else {
                // Son varios médicos en el mismo domicilio
                unifiedCentersNames.push(`CONSULTORIOS ${first.calle} ${first.altura} <span class="text-muted">[Integró a: ${uniqueNormalizedNamesInGroup.join(', ')}]</span>`);
              }
          }
      });

      let finalHtml = `
        <div class="text-left border-bottom pb-2 mb-3">
          <p class="mb-1"><i class="fas fa-file-pdf text-danger"></i> Registros en PDF original: <b>${allRecords.length}</b></p>
          <p class="mb-1"><i class="fas fa-object-group text-primary"></i> Centros únicos detectados: <b>${totalGroups}</b></p>
          <p class="mb-0 text-muted small"><i class="fas fa-compress-arrows-alt"></i> Se redujeron <b>${consolidatedRecordsCount}</b> duplicados mediante unificación.</p>
        </div>

        <div class="bg-light p-2 rounded border mb-3">
          <p class="mb-1 text-success"><i class="fas fa-check-double"></i> Creados exitosamente: <b>${centersCreated}</b></p>
          <p class="mb-0 text-info"><i class="fas fa-history"></i> Omitidos (ya existían): <b>${centersSkipped}</b></p>
        </div>

        <!-- 📊 BLOQUE NUEVO: Auditoría de Especialistas Multi-Centro -->
        <div class="mt-3 p-3 border rounded bg-white shadow-sm">
           <h6 class="font-weight-bold text-dark border-bottom pb-2 mb-3">
             <i class="fas fa-user-md text-primary mr-2"></i> Auditoría: Especialistas Multi-Centro
           </h6>
           <div class="row text-center mb-3">
              <div class="col-4 border-right">
                 <p class="small text-muted mb-1">Especialistas Únicos</p>
                 <h5 class="font-weight-bold mb-0">${specialistGroups.size - (specialistGroups.has('S/C') ? 1 : 0)}</h5>
              </div>
              <div class="col-4 border-right">
                 <p class="small text-muted mb-1">En varios centros</p>
                 <h5 class="font-weight-bold mb-0 text-primary">${multiCenterCount}</h5>
              </div>
              <div class="col-4">
                 <p class="small text-muted mb-1">Con Inconsistencias</p>
                 <h5 class="font-weight-bold mb-0 ${totalInconsistent > 0 ? 'text-danger' : 'text-success'}">${totalInconsistent}</h5>
              </div>
           </div>

           ${multiCenterAudit.length > 0 ? `
              <div class="mt-2 text-left">
                  <p class="small font-weight-bold mb-1"><i class="fas fa-search-location"></i> Detalle de especialistas detectados:</p>
                  <div style="max-height: 150px; overflow-y: auto;" class="border rounded p-2 bg-light">
                    <ul class="list-unstyled mb-0 small">
                        ${multiCenterAudit.map(audit => `
                          <li class="mb-2 pb-2 border-bottom last-child-no-border">
                            <div class="d-flex justify-content-between align-items-center">
                                <span>
                                  <b class="text-dark">${audit.name}</b> <br>
                                  <span class="text-muted small">Cod: ${audit.code} - Centros: ${audit.centersCount} <br> <i>(${audit.centersList.join(' / ')})</i></span>
                                </span>
                                <span class="badge ${audit.isValid ? 'badge-success' : 'badge-danger'} p-2">
                                  <i class="fas ${audit.isValid ? 'fa-check-circle' : 'fa-exclamation-triangle'} mr-1"></i>
                                  ${audit.isValid ? 'Espec. OK' : 'Falta Espec.'}
                                </span>
                            </div>
                          </li>
                        `).join('')}
                    </ul>
                  </div>
              </div>
           ` : ''}
        </div>
      `;

      if (unifiedCentersNames.length > 0) {
        finalHtml += `
          <div class="mt-3">
            <p class="small font-weight-bold mb-1"><i class="fas fa-list-check"></i> Centros Unificados (Consolidando especialidades):</p>
            <ul style="text-align: left; max-height: 120px; overflow-y: auto; font-size: 0.85rem;" class="text-primary italic">
              ${unifiedCentersNames.map(name => `<li>${name}</li>`).join('')}
            </ul>
          </div>
        `;
      }

      if (centersFailed > 0) {
        finalTitle = 'Completado con Incidencias';
        finalIcon = 'warning';
        finalHtml += `
          <div class="alert alert-danger p-2 mt-3">
            <p class="mb-0 small"><i class="fas fa-exclamation-circle text-danger"></i> Fallaron: <b>${centersFailed}</b></p>
          </div>
          <p class="small mt-2 mb-1 font-weight-bold">Detalle de fallos:</p>
          <ul style="text-align: left; max-height: 100px; overflow-y: auto; font-size: 0.8rem;">
            ${failedRecordsList.map(f => `<li>${f.especialista} (${f.domicilio})</li>`).join('')}
          </ul>
        `;
      }
      
      finalHtml += `</div>`;

      // Guardar historial de importación
      const historyRecord = {
        tipo: 'PADRON_MDP',
        gerenciadoraName: this.resGerenciadora?.nombre || 'Padrón Mar Del Plata',
        filename: this.selectedFile ? this.selectedFile.name : 'sin_nombre.pdf',
        totalRecords: allRecords.length,
        totalCenters: totalGroups,
        geolocatedCenters: totalGroups - this.unmatchedAddresses.length,
        unmatchedCenters: this.unmatchedAddresses.length,
        createdCount: centersCreated,
        skippedCount: centersSkipped,
        failedCount: centersFailed,
        detallesCreados: [],
        detallesFallidos: failedRecordsList.map(f => ({
          nombre: f.especialista,
          domicilio: f.domicilio,
          error: f.error
        }))
      };
      await this.padronesService.saveImportHistory(historyRecord).catch(err => console.error("Error saving history:", err));

      await Swal.fire({
        title: finalTitle,
        icon: finalIcon,
        html: finalHtml,
        confirmButtonText: this.showUnifyButton ? 'Cerrar y Ver Opciones' : 'Entendido, Finalizar'
      });
      
      // No recargar automáticamente si queremos dar la opción de unificar
      if (!this.showUnifyButton) {
        window.location.reload();
      }

    } catch (error) {
      console.error('Error general en la migración:', error);
      Swal.fire('Error', 'No se pudo completar la migración de datos.', 'error');
    } finally {
      this.isMigratingData = false;
    }
  }

  // --- FASE 6: UNIFICACIÓN POST-PROCESO (Limpieza de domicilios duplicados por nomenclador/nombre) ---
  async unifyCentersPostProcess(gerenciadoraId: string) {
    Swal.fire({
      title: 'Optimizando Centros Médicos',
      html: '<p><i class="fas fa-broom mr-2"></i> Unificando por nombre de dirección (CONSULTORIOS)...</p>',
      allowOutsideClick: false,
      didOpen: () => { Swal.showLoading(); }
    });

    try {
      const allCentros = await this.signoCentroMedicoService.getCentroMedicos();
      const getId = (item: any) => {
        if (!item) return null;
        if (typeof item === 'string') return item;
        return item._id || item.$oid || (typeof item === 'object' ? null : item);
      };
      const myCentros = allCentros.filter(c => getId(c.gerenciadora) === gerenciadoraId);

      // Agrupar por nombre maestro (Limpiando "CONSULTORIOS" y sufijos de numeración como " 3")
      const groupsMap = new Map<string, any[]>();
      myCentros.forEach(c => {
         const rawName = (c.nombre || '').toUpperCase().trim();
         let cleanName = rawName
            .replace(/^CONSULTORIOS\s+/i, '') // Quitar prefijo "Consultorios"
            .replace(/\s+/g, ' ')             // Normalizar espacios
            .replace(/\(C\d+\)$/i, '')        // Quitar sufijos (C1), (C2)
            .trim();

         // REGLA INTELIGENTE: Si el nombre termina en un espacio + número (ej: "COLON 3629 3")
         // y EL RESTO del nombre YA TIENE un número (ej: "COLON 3629"), 
         // asumimos que el último es un sufijo de copia y lo removemos.
         const lastNumberMatch = cleanName.match(/\s+(\d+)$/);
         if (lastNumberMatch) {
            const potentialBase = cleanName.substring(0, lastNumberMatch.index).trim();
            if (/\d+/.test(potentialBase)) {
               cleanName = potentialBase; // Reducimos (ej: "COLON 3629 3" -> "COLON 3629")
            }
         }

         if (!groupsMap.has(cleanName)) groupsMap.set(cleanName, []);
         groupsMap.get(cleanName).push(c);
      });

      const auditUnified: { name: string, count: number, integrated: string[] }[] = [];

      for (const [cleanBase, centers] of Array.from(groupsMap.entries())) {
         if (centers.length > 1) {
            const master = centers[0];
            const others = centers.slice(1);
            const fullName = `CONSULTORIOS ${cleanBase}`;
            const integratedNames = others.map(o => o.nombre).filter(n => n);

            const uniqueEspecIds = new Set<string>();
            const uniqueRubroIds = new Set<string>();
            const uniquePlanIds = new Set<string>();
            const uniquePhones = new Set<string>();

            centers.forEach(c => {
               (c.especialidades || []).forEach(e => { if(getId(e)) uniqueEspecIds.add(getId(e)); });
               (c.rubros || []).forEach(r => { if(getId(r)) uniqueRubroIds.add(getId(r)); });
               (c.planes || []).forEach(p => { if(getId(p)) uniquePlanIds.add(getId(p)); });
               (c.telefonos || '').split('/').forEach(t => { if(t.trim() && t.trim() !== '0') uniquePhones.add(t.trim()); });
            });

            const match = cleanBase.match(/^(.+?)\s+(\d+)$/);
            if (match) {
               master.calle = match[1].trim();
               master.altura = match[2].trim();
            } else {
               master.calle = cleanBase;
               master.altura = '0';
            }

            for (const other of others) { 
               try {
                  await this.signoCentroMedicoService.deleteOne(other._id); 
               } catch (e) {
                  console.error('Error al eliminar duplicate id:', other._id);
               }
            }

            const cleanDto: any = {
               nombre: fullName,
               activo: true,
               calle: master.calle,
               altura: master.altura,
               pisoDpto: master.pisoDpto || '',
               zona: { _id: getId(master.zona) },
               localidad: { _id: getId(master.localidad) },
               telefonos: Array.from(uniquePhones).join(' / ') || '0',
               celular: master.celular || '',
               horarios: master.horarios || 'Padrón',
               latitud: Number(master.latitud) || 0,
               longitud: Number(master.longitud) || 0,
               rubros: Array.from(uniqueRubroIds).map(id => ({ _id: id })),
               especialidades: Array.from(uniqueEspecIds).map(id => ({ _id: id })),
               planes: Array.from(uniquePlanIds).map(id => ({ _id: id })),
               gerenciadora: { _id: getId(master.gerenciadora) || this.lastGerenciadoraId }
            };

            try {
               await this.signoCentroMedicoService.updateCentroMedico(master._id, cleanDto);
               auditUnified.push({ 
                  name: fullName, 
                  count: centers.length, 
                  integrated: integratedNames 
               });
            } catch (e) {
               console.error('Error al actualizar registro maestro:', cleanDto.nombre);
            }
         }
      }

      // INFORME FINAL DE ÉXITO DETALLADO (Petición Usuario con Métricas)
      const totalGrupos = auditUnified.length;
      const totalCentrosFusionados = auditUnified.reduce((acc, curr) => acc + curr.count, 0);

      let auditHtml = `
        <div class="text-left mt-3">
          <p class="small font-weight-bold mb-2 pb-1 border-bottom">
            <i class="fas fa-clipboard-check text-success mr-1"></i> Centros Consolidados: 
            <span style="background: #17a2b8; color: white; padding: 1px 6px; border-radius: 10px; font-size: 0.7rem; margin-left: 4px; display: inline-block;">${totalGrupos} Grupos</span>
            <span style="background: #007bff; color: white; padding: 1px 6px; border-radius: 10px; font-size: 0.7rem; margin-left: 4px; display: inline-block;">${totalCentrosFusionados} Registros Fusionados</span>
          </p>
          <ul style="max-height: 280px; overflow-y: auto; font-size: 0.8rem; padding-left: 1rem;" class="list-unstyled">
            ${auditUnified.length > 0 
                ? auditUnified.map(a => `
                    <li class="mb-3">
                      <div class="text-primary font-weight-bold" style="font-size: 0.88rem;">
                        <i class="fas fa-hospital-symbol mr-1"></i> ${a.name}
                      </div>
                      <div class="text-muted border-left pl-2 ml-2 mt-1" style="font-style: italic; line-height: 1.2;">
                        <small>Unificó ${a.count} fichas:</small><br/>
                        ${a.integrated.join(', ')}
                      </div>
                    </li>`).join('')
                : '<li>No se detectaron nuevos duplicados para unificar.</li>'
            }
          </ul>
          <div class="mt-3 p-2 bg-light border rounded" style="font-size: 0.7rem; color: #555; line-height: 1.3;">
            <i class="fas fa-info-circle mr-1"></i> <b>Control Técnico / Vista:</b><br/>
            Se aplicó limpieza de nombres para casos como <i>"CONSULTORIOS COLON 3629"</i> 
            usando expresiones regulares para unificar sufijos redundantes (ej: " 2", " 3").
          </div>
        </div>
      `;

      await Swal.fire({
          title: '¡Optimización Completada! 🎯',
          icon: 'success',
          html: auditHtml,
          confirmButtonText: 'Entendido',
          allowOutsideClick: false
      });

      this.hasUnified = true;
      this.cdr.detectChanges();

    } catch (error) {
       console.error('Error en el pos-proceso:', error);
       Swal.fire('Error', 'No se pudieron unificar todos los centros correctamente.', 'error');
    } finally {
       // Swal.close() is now implicitly handled by the success message above
    }
  }

  async migratePharmaciesToCentros() {
    try {
      this.isMigratingData = true;
      this.createdPharmaciesSummary = [];
      this.pharmacyMigrationFailures = [];
      const { codigoArea } = this.step1Form.value;
      const selectedPlanesIds = this.pharmacyForm.value.planesIds || [];

      // 1. Cargar todas las localidades para mapeo de zonas
      const allLocalidades = await this.localidadService.getLocalidades();
      this.localidadZonaMap = {};
      allLocalidades.forEach(loc => {
        const zId = loc.zona && (typeof loc.zona === 'string' ? loc.zona : loc.zona._id || (loc.zona as any).$oid);
        if (zId) {
          this.localidadZonaMap[loc._id] = zId;
        }
      });

      // 2. Obtener todos los registros temporales de farmacias
      const allPharmacies = await this.padronFarmaciasService.getPharmacyAllRecords();
      const getId = (id: any): string => {
        if (!id) return '';
        if (typeof id === 'object') {
          if (id._id) return getId(id._id);
          if (id.$oid) return id.$oid;
        }
        return id.toString();
      };

      if (allPharmacies.length === 0) {
        Swal.fire('Info', 'No hay farmacias para procesar.', 'info');
        this.isMigratingData = false;
        return;
      }

      // 2. AGRUPAR POR DOMICILIO
      const groupsMap = new Map<string, any[]>();
      allPharmacies.forEach(rec => {
        const key = `${rec.calle || ''}-${rec.altura || ''}-${getId(rec.signoLocalidad) || ''}`.trim().toUpperCase();
        if (!groupsMap.has(key)) groupsMap.set(key, []);
        groupsMap.get(key).push(rec);
      });

      const totalGroups = groupsMap.size;
      this.geoInitialCount = totalGroups;
      this.geoCurrentCount = 0;
      this.geoProgress = 0;

      // 3. Cargar existentes para control de duplicados
      const allExisting = await this.signoCentroMedicoService.getCentroMedicos();

      let centersCreated = 0;
      let centersFailed = 0;
      let centersSkipped = 0;
      const failedRecordsList: any[] = [];

      // 4. Procesar Grupos
      for (const [key, groupRecords] of Array.from(groupsMap.entries())) {
        this.geoCurrentCount++;
        this.geoProgress = Math.round((this.geoCurrentCount / this.geoInitialCount) * 100);

        const first = groupRecords[0];
        let nombreCentro = '';
        
        // Para farmacias, usualmente el nombre es el de la farmacia. 
        // Si hay varias en el mismo sitio, usamos el nombre de la primera o un consolidado.
        if (groupRecords.length === 1) {
          nombreCentro = first.farmacia.toUpperCase();
        } else {
          nombreCentro = `FARMACIAS ${first.calle || ''} ${first.altura || ''}`.trim().toUpperCase();
        }

        const currentGerId = getId(first.gerenciadora) || this.resGerenciadora?._id;
        const normStr = (s: string) => (s || '').trim().toUpperCase();
        const normalizarTexto = (value: any): string => {
          if (!value) return '';
          return value
            .toString()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/[^\w\s]/gi, ' ')
            .replace(/\s+/g, ' ')
            .trim()
            .toLowerCase();
        };
        
        const targetName = normalizarTexto(nombreCentro);

        // Check duplicate in the real centers collection again (just in case)
        const exists = allExisting.find(c => {
           const dbNameNorm = normalizarTexto(c.nombre);
           return dbNameNorm === targetName;
        });

        if (exists) {
           centersSkipped++;
           continue;
        }

        const uniqueEspecIds = new Set<string>();
        const uniqueRubroIds = new Set<string>();
        const uniquePhones = new Set<string>();

        const isObjectId = (id: string) => id && /^[0-9a-fA-F]{24}$/.test(id);

        groupRecords.forEach(r => {
          const eId = getId(r.especialidad);
          const rId = getId(r.rubro);

          if (eId && isObjectId(eId)) uniqueEspecIds.add(eId);
          if (rId && isObjectId(rId)) uniqueRubroIds.add(rId);
          
          // Procesar teléfonos de farmacias conservando el formato de Excel/manual
          if (r.telefono && r.telefono.trim()) {
            const parts = r.telefono.split(/[\/\|,]/);
            parts.forEach(p => {
              const trimmed = p.trim();
              if (trimmed && trimmed !== '0') {
                uniquePhones.add(trimmed);
              }
            });
          }
        });

        const bestCoord = groupRecords.find(r => Number(r.latitud) !== 0) || first;

        // Determinar Localidad (con fallback por nombre si el ID del backend falló)
        let locId = first.signoLocalidad || this.resLocalidad?._id;
        
        if (!isObjectId(locId) && first.localidad) {
          const lMatch = allLocalidades.find(l => 
            normStr(l.nombre) === normStr(first.localidad) || 
            normStr(l.nombre).includes(normStr(first.localidad))
          );
          if (lMatch) locId = lMatch._id;
        }

        // Determinar Zona automáticamente por Localidad
        const autoZonaId = locId ? this.localidadZonaMap[locId] : null;
        const finalZonaId = autoZonaId || first.signoZona || this.resZona?._id;

        // VALIDACIÓN CRÍTICA: No intentar crear sin IDs válidos (evita 500 de Mongoose)
        if (!isObjectId(locId) || !isObjectId(finalZonaId)) {
          centersFailed++;
          this.pharmacyMigrationFailures.push({
             farmacia: nombreCentro,
             domicilio: first.domicilio,
             provincia: first.provincia || 'SIN DATOS',
             localidad: first.localidad || 'SIN DATOS',
             error: `Falta Mapeo: ${!isObjectId(locId) ? 'Localidad' : ''} ${!isObjectId(finalZonaId) ? 'Zona' : ''}`.trim()
          });
          continue;
        }

        const centroMedico: any = {
           nombre: nombreCentro,
           activo: true,
           calle: first.calle || first.domicilio?.split(' ')[0] || 'S/N',
           altura: first.altura || '0',
           pisoDpto: '',
           zona: { _id: finalZonaId },
           localidad: { _id: locId },
            telefonos: Array.from(uniquePhones).join(', ') || '0',
            celular: '',
            horarios: 'Padrón Farmacias',
            latitud: Number(bestCoord.latitud) || 0,
            longitud: Number(bestCoord.longitud) || 0,
            rubros: Array.from(uniqueRubroIds).map(id => ({ _id: id })),
            especialidades: Array.from(uniqueEspecIds).map(id => ({ _id: id })),
            planes: selectedPlanesIds.map(id => ({ _id: id })), 
            gerenciadora: (currentGerId && isObjectId(currentGerId)) ? { _id: currentGerId } : null
         };

        try {
           await this.signoCentroMedicoService.createSilent(centroMedico);
           centersCreated++;

           // Buscar nombre de la zona para el reporte
           const zonaObj = this.zonas.find(z => z._id === finalZonaId);
           this.createdPharmaciesSummary.push({
              nombre: nombreCentro,
              zona: zonaObj ? zonaObj.concepto : 'ZONA NO DEFINIDA',
              provincia: first.provincia || 'SIN DATOS',
              localidad: first.localidad || 'SIN DATOS'
           });

        } catch (err: any) {
           console.error('ERROR AL CREAR FARMACIA:', nombreCentro, err);
           centersFailed++;
           this.pharmacyMigrationFailures.push({
              farmacia: nombreCentro,
              domicilio: first.domicilio,
              provincia: first.provincia || 'SIN DATOS',
              localidad: first.localidad || 'SIN DATOS',
              error: err.message || 'Error API'
           });
        }
      }

      // 5. Agrupar localidades fallidas para el reporte
      const uniqueFailedLocs = new Set<string>();
      this.pharmacyMigrationFailures.forEach(f => {
        if (f.error.includes('Falta Mapeo: Localidad')) {
          const loc = (f.localidad || '').trim();
          if (loc && loc !== 'SIN DATOS') {
            uniqueFailedLocs.add(loc);
          }
        }
      });
      this.failedLocalitiesSummary = Array.from(uniqueFailedLocs).sort();

      // Guardar historial de importación
      const historyRecord = {
        tipo: 'FARMACIAS',
        gerenciadoraName: this.selectedPharmacyGerenciadoraName || 'Farmacias',
        filename: this.pharmacyFile ? this.pharmacyFile.name : 'sin_nombre.xlsx',
        totalRecords: allPharmacies.length,
        totalCenters: totalGroups,
        geolocatedCenters: this.pharmacyImportResult?.geolocatedCenters || 0,
        unmatchedCenters: this.pharmacyImportResult?.unmatchedCenters || 0,
        duplicatesCount: this.pharmacyDuplicates?.length || 0,
        createdCount: centersCreated,
        skippedCount: centersSkipped,
        failedCount: centersFailed,
        detallesCreados: this.createdPharmaciesSummary.map(c => c.nombre),
        detallesFallidos: this.pharmacyMigrationFailures.map(f => ({
          nombre: f.farmacia,
          domicilio: f.domicilio,
          error: f.error
        }))
      };
      await this.padronesService.saveImportHistory(historyRecord).catch(err => console.error("Error saving history:", err));

      // 6. INFORME FINAL (Simplificado, la grilla está en el componente)
      await Swal.fire({
        title: '¡Migración de Farmacias! 💊',
        icon: centersFailed > 0 ? 'warning' : 'success',
        width: '500px',
        html: `
          <div class="text-left" style="font-size: 1rem;">
            <p>Se crearon <b>${centersCreated}</b> locales de farmacia.</p>
            <p>Se omitieron <b>${centersSkipped}</b> duplicados.</p>
            ${centersFailed > 0 ? `<p class="text-danger font-weight-bold">Fallaron <b>${centersFailed}</b> registros. Ver detalles en la tabla debajo.</p>` : ''}
          </div>
        `,
        confirmButtonText: 'Ver Resultados'
      });

      this.migrationFinished = true;

    } catch (error) {
       console.error('Error general en la migración de farmacias:', error);
       Swal.fire('Error', 'No se pudo completar la migración de farmacias.', 'error');
    } finally {
      this.isMigratingData = false;
    }
  }

  reloadPage() {
    window.location.reload();
  }
}
